module.exports = __webpack_public_path__ + "img/vip-icon-1.961a001f.png";